'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('recomModule')

    .factory('recomActionPlanUpdateStatusService', ['$http', 'env', '$q', function ($http, env, $q) {

        var baseUrl = environment.apiUrl + '/Pilot/api/Recom/ActionPlanUpdateStatus';

        var service = {};

        // Get Action Plan Update Status Lookups
        service.getActionPlanUpdateStatusLookups = function () {
            var reqUrl = baseUrl + '/Lookup';

            return $http
                    .get(reqUrl, { cache: true })
                    .then(function (response) { return response.data; })
        };

        // Get Owners and Statuses
        service.getOwnersAndStatus = function (businessUnitId) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/OwnersAndStatus';

            return $http
                .get(reqUrl)
                .then(function (response) { return response.data; })
        };

        // Send Reminder to Owner
        service.sendReminderToOwner = function (businessUnitId, owner, recomContainerOwnerReminder) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/OwnersAndStatus/SendReminderToOwner';

            // Used during development to simulate sending the email
            var isDebug = env.isDev || undefined;

            return $http
                .post(reqUrl, {
                    isDebug: isDebug,
                    owner: owner,
                    recomContainerOwnerReminder: recomContainerOwnerReminder
                })
                .then(function (response) { return response.data; });
        };

        // Get Owner Tasks
        service.getOwnerTasks = function () {
            var reqUrl = baseUrl + '/TasksByOwner';

            return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
        };

        // Get Available Business Units
        service.getAvailableBusinessUnits = function () {
            var reqUrl = baseUrl + '/BusinessUnit/Available';

            return $http
                    .get(reqUrl)
                    .then(function (response) { return response.data; })
        };

        // Get Action plan assessments By Assessor
        service.getActionPlanAssessmentsByAssessor = function (businessUnitId, assessorID) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/Assessor@' + assessorID + '/ActionPlan';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Get Assessments By Assessor and By Action plan
        service.getAssessmentsByAssessorAndActionPlan = function (businessUnitId, assessorID, planInitiativeId) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/Assessor@' + assessorID + '/ActionPlan/' + planInitiativeId;

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Assess Action Plan Criteria
        service.assessActionPlanCriteria = function (assessorId, actionPlanId, actionPlanCriteriaId, assessment) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId;

            return $http
                .post(reqUrl, assessment)
                .then(function (response) { return response.data; });
        };

        // Reset Action Plan Criteria Assessment
        service.resetActionPlanCriteriaAssessment = function (assessorId, actionPlanId, actionPlanCriteriaId, assessment) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Reset';

            return $http
                .post(reqUrl, assessment)
                .then(function (response) {
                    return response.data;
                });
        };

        // Get FollowUps by Action Plan Criteria AssessmentID
        service.getFollowUpsByActionPlanCriteriaAssessmentID = function (assessorId, actionPlanId, actionPlanCriteriaId, assessmentId) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Assessment/' + assessmentId + '/FollowUp';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Create Criteria Assessment FollowUp
        service.createActionPlanCriteriaAssessmentFollowUp = function (assessorId, actionPlanId, actionPlanCriteriaId, assessmentId, followUp) {
            var reqUrl = baseUrl + '/Assessor@' + assessorId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Assessment/' + assessmentId + '/FollowUp';

            return $http.post(reqUrl, followUp)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Assess Action Plan
        service.assessActionPlan = function (assessorID, actionPlanId, assessment) {
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/ActionPlan/' + actionPlanId;

            return $http.post(reqUrl, assessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Get Assessments To Review By Assessor
        service.getActionPlanAssessmentsToReviewByAssessor = function (businessUnitId, assessorID) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/Assessor@' + assessorID + '/ActionPlan/ToReview';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Get Assessments To Review By Assessor and Action Plan
        service.getAssessmentsToReviewByAssessorAndActionPlan = function (businessUnitId, assessorID, actionPlanId) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/Assessor@' + assessorID + '/ActionPlan/' + actionPlanId + '/ToReview';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Get FollowUps by Action Plan Criteria AssessmentID For Review
        service.getFollowUpsForReviewerByActionPlanCriteriaAssessmentID = function (businessUnitId, actionPlanId, actionPlanCriteriaId, assessmentId) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Assessment/' + assessmentId + '/FollowUp/ForReview';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Create Criteria Assessment FollowUp For Review
        service.createActionPlanCriteriaReviewFollowUp = function (businessUnitId, actionPlanId, actionPlanCriteriaId, assessmentId, followUp) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Assessment/' + assessmentId + '/FollowUp/ForReview';

            return $http.post(reqUrl, followUp)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Get download url for Criteria Assessment
        service.getDownloadAttachmentUrl = function (businessUnitId, actionPlanId, actionPlanCriteriaId, assessmentId, attachmentId) {
            return baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Assessment/' + assessmentId + '/FollowUp/Attachment/' + attachmentId;
        };

        // Review Action Plan Criteria Assessment
        service.reviewActionPlanCriteriaAssessment = function (businessUnitId, actionPlanId, actionPlanCriteriaId, assessment) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Criteria/' + actionPlanCriteriaId + '/Review';

            return $http.post(reqUrl, assessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Review Action Plan Assessment
        service.reviewActionPlanAssessment = function (businessUnitId, actionPlanId, assessment) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Review';

            return $http.post(reqUrl, assessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Update Action Plan Review Comment
        service.updateActionPlanAssessmentReviewComment = function (actionPlanId, businessUnitId, actionPlanAssessment) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/ReviewComment';

            return $http.post(reqUrl, actionPlanAssessment)
		        .then(function (response) {
			        return response.data;
		        });
        };

        // Lock Action Plan Assessment
        service.lockActionPlanAssessment = function (businessUnitId, actionPlanId, assessment) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Lock';

            return $http.post(reqUrl, assessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Unlock Action Plan Assessment
        service.unlockActionPlanAssessment = function (businessUnitId, actionPlanId, assessment) {
            var reqUrl = baseUrl + '/BusinessUnit/' + businessUnitId + '/ActionPlan/' + actionPlanId + '/Unlock';

            return $http.post(reqUrl, assessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        return service;
    }]);
